import React, { useEffect, useState } from 'react';
import { Card, Container, Row } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { get, isEmpty } from 'lodash';
import DynamicForm from 'screens/common/dynamicForm';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { cropCalendarApi } from 'api/endpoints/CropCalender';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

function CropCalendar(props) {
  const tenant = getTenantFromToken();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const { id } = useParams();
  const isEditMode = !!id;

  const fetchFormData = async () => {
    try {
      const formResponse = await cropCalendarApi.createCropCalendarForm();
      setData(formResponse.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
      toast.error('Failed to load form data');
    }
  };

  const fetchEditFormData = async id => {
    try {
      const formResponse = await cropCalendarApi.editCropCalendarForm(id);
      setData(formResponse.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
      toast.error('Failed to load form data');
    }
  };

  useEffect(() => {
    if (isEditMode) {
      fetchEditFormData(id);
    } else {
      fetchFormData();
    }
  }, [tenant]);

  const handleFormSubmit = async formData => {
    try {
      let response;
      if (isEditMode) {
        try {
          response = await cropCalendarApi.updateCropCalendar(id, formData);
          formSubmissionToast(response, toast, 'Crop Calendar', true);
          navigate(`/${tenant}/cropcalendarRuleReport`);
        } catch (updateErr) {
          formSubmissionToast(updateErr, toast, 'Crop Calendar', true);
          return; // Stop further execution on error
        }
      } else {
        // Create new Crop Calendar
        try {
          response = await cropCalendarApi.submitCropCalendar(formData);
          formSubmissionToast(response, toast, 'Crop Calendar');
          navigate(`/${tenant}/cropcalendarRuleReport`);
        } catch (createErr) {
          formSubmissionToast(createErr, toast, 'Crop Calendar');
          return; // Stop further execution on error
        }
      }
    } catch (err) {
      formSubmissionToast(err, toast, 'Unexpected error occurred');
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/cropcalendarRuleReport`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>{isEditMode ? 'Edit Crop Calendar' : 'Create Crop Calendar'}</span>
    </div>
  );

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header>
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body>
            {!isEmpty(data) && (
              <DynamicForm
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
                mode={isEditMode && 'edit'}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
}

export default CropCalendar;
